var map = {
	"./": 45265,
	"./common": 52152,
	"./common.js": 52152,
	"./getters": 59769,
	"./getters.js": 59769,
	"./index": 45265,
	"./margin.accounts": 14569,
	"./margin.accounts.js": 14569,
	"./margin.balance": 31165,
	"./margin.balance.js": 31165,
	"./margin.composite": 31374,
	"./margin.composite.js": 31374,
	"./margin.funding": 44312,
	"./margin.funding.js": 44312,
	"./margin.indice": 89285,
	"./margin.indice.js": 89285,
	"./margin.instrument": 58540,
	"./margin.instrument.js": 58540,
	"./margin.insurance": 40269,
	"./margin.insurance.js": 40269,
	"./margin.leaderboard": 14770,
	"./margin.leaderboard.js": 14770,
	"./margin.order": 61321,
	"./margin.order.js": 61321,
	"./margin.orderbook": 26296,
	"./margin.orderbook.js": 26296,
	"./margin.position": 66314,
	"./margin.position.js": 66314,
	"./margin.setting": 6021,
	"./margin.setting.js": 6021,
	"./margin.settlement": 19714,
	"./margin.settlement.js": 19714,
	"./margin.symbol": 65249,
	"./margin.symbol.js": 65249,
	"./mutations": 12153,
	"./mutations.js": 12153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19475;